import { Injectable } from "@angular/core";
import { IHandleLinkQuery, ILinkHandling } from "@gloria-public/register/domain/interfaces/handle-link.interface";
import { ApiService } from "@shared/services/api.service";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class HandleLinkService {
  constructor(private api: ApiService) {}

  /**
   * Handles link redirection
   * @param params Query parameters (IHandleLinkQuery)
   * @returns Redirection information
   */
  public handleLink(params: IHandleLinkQuery): Observable<ILinkHandling> {
    const queryParams: Record<string, string> = {
      token: params.token,
      origin: params.origin,
    };

    return this.api.get("handle-link", queryParams, false) as Observable<ILinkHandling>;
  }
}
